import { API_G_080_KOJO_DEKIDAKA_ENTRY } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_080: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getKojoDekidakaEntry(_ctx, params) {
      try {
        const res = await axios({
          url: API_G_080_KOJO_DEKIDAKA_ENTRY,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getKojoDekidakaEntry error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async postKojoDekidakaEntry(_ctx, requestData) {
      try {
        const res = await axios({
          url: API_G_080_KOJO_DEKIDAKA_ENTRY,
          data: {
            requestData,
          },
          method: 'POST',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api postKojoDekidakaEntry error.');
        console.log(err);
      }
    },
    async getKojoDekidakaEntryItem(_ctx, params) {
      try {
        const { kyoryokuKojoCd, himmokuCd, seizoYmd } = params;

        const res = await axios({
          url: `${API_G_080_KOJO_DEKIDAKA_ENTRY}/${kyoryokuKojoCd}/${himmokuCd}/${seizoYmd}`,
          method: 'GET',
          params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getKojoDekidakaEntryItem error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putKojoDekidakaEntryItem(_ctx, requestData) {
      try {
        const { kyoryokuKojoCd, himmokuCd, seizoYmd } =
          requestData.kojoDekidakaData;

        const res = await axios({
          url: `${API_G_080_KOJO_DEKIDAKA_ENTRY}/${kyoryokuKojoCd}/${himmokuCd}/${seizoYmd}`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putKojoDekidakaEntryItem error.');
        console.log(err);
      }
    },
    async deleteKojoDekidakaEntryItem(_ctx, params) {
      try {
        const { kyoryokuKojoCd, himmokuCd, seizoYmd } = params;

        const res = await axios({
          url: `${API_G_080_KOJO_DEKIDAKA_ENTRY}/${kyoryokuKojoCd}/${himmokuCd}/${seizoYmd}`,
          params,
          method: 'DELETE',
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api deleteKojoDekidakaEntryItem error.');
        console.log(err);
      }
    },
  },
};

export default g_080;
